<template>
  <div class="carousel">
    <div class="swiper-container" id="bannerswiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(img, i) in imgs" :key="i">
          <div class="banner">
            <div v-if="exp.isPath.test(img.HerfUrl)">
              <router-link :to="{path:img.HerfUrl}">
                <img :src="img.Img" alt />
              </router-link>
            </div>
            <div v-else>
              <a :href="'http://'+img.HerfUrl" target="_blank" rel="noopener noreferrer">
                <img :src="img.Img" alt />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { getOnce } from "@/libs/axios";
import Exp from "@/libs/Exp";

export default {
  data() {
    return {
      imgs: [],
      exp: Exp
    };
  },
  methods: {
    initSwiper() {
      console.log(Exp.isPath.test("///"));
      var mySwiper1 = new Swiper("#bannerswiper", {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        speed: 300,
        direction: "horizontal", // 垂直切换选项
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
          clickable: true
        }
      });
      mySwiper1.el.onmouseover = function() {
        mySwiper1.autoplay.stop();
      };
      mySwiper1.el.onmouseout = function() {
        mySwiper1.autoplay.start();
      };
    }
  },
  mounted() {
    getOnce("/Member/RZJPageIndex/BannerData").then(result => {
      this.imgs = result.Banners;
      this.$nextTick(() => {
        this.initSwiper();
      });
    });
  }
};
</script>

<style scoped>
.carousel {
  height: 403px;
  width: 100%;
}
.swiper-container {
  width: 100%;
}
.swiper-pagination {
  bottom: 60px !important;
  cursor: pointer;
}
.banner {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 403px;
}
.banner a {
  width: 100%;
  height: 100%;
  display: block;
}
.banner a img {
  height: 403px;
  position: absolute;
  left: 50%;
  display: block;
  transform: translate(-50%);
  cursor: pointer;
}
.swiper-pagination /deep/ .my-bullet {
  display: inline-block;
  width: 60px;
  height: 2px;
  background: #fff;
  border-radius: 1px;
  opacity: 0.4;
  margin: 0 4px;
  top: 40px;
}
.swiper-pagination >>> .my-bullet-active {
  opacity: 1;
}
</style>
